import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { initialState, ProductsImportState, GENERATED_QR_SLICE_NAME } from './models';
import { getGeneratedQrList, createProductsQrList } from './actionCreators';

export const slice = createSlice({
  name: GENERATED_QR_SLICE_NAME,
  initialState,
  reducers: {
    resetGeneratedQrState() {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGeneratedQrList.fulfilled, (state: ProductsImportState, action) => {
        state.isLoading = false;
        state.productsQrList = action.payload;
      })
      .addCase(createProductsQrList.fulfilled, (state: ProductsImportState) => {
        state.isLoading = false;
      })
      .addMatcher(isPending(getGeneratedQrList, createProductsQrList), (state: ProductsImportState) => {
        state.isLoading = true;
      })

      .addMatcher(isRejected(getGeneratedQrList, createProductsQrList), (state: ProductsImportState, action) => {
        const { error } = action;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export const { resetGeneratedQrState } = slice.actions;

export default slice.reducer;
